<div class="add-candidate-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>Processing candidate data...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isLoading" class="error-container">
    <div class="error-icon">⚠️</div>
    <h2>Error Processing Candidate</h2>
    <p>{{ errorMessage }}</p>
    <button class="btn btn-secondary" (click)="onCancelAddCandidate()">
      Return to Dashboard
    </button>
  </div>

  <!-- Confirmation Dialog -->
  <div *ngIf="showConfirmation && candidateData && !isLoading" class="confirmation-container">
    <div class="confirmation-header">
      <h2>Add New Candidate</h2>
      <p>Would you like to add this candidate to your contacts?</p>
    </div>

    <div class="candidate-details">
      <div class="detail-row">
        <span class="label">Job Application ID:</span>
        <span class="value">{{ candidateData.JAId }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Email:</span>
        <span class="value">{{ candidateData.email }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Phone:</span>
        <span class="value">{{ candidateData.phone }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Job Title:</span>
        <span class="value">{{ candidateData.jobTitle }}</span>
      </div>
      <div class="detail-row">
        <span class="label">MC ID:</span>
        <span class="value">{{ candidateData.MCId }}</span>
      </div>
    </div>

    <div class="action-buttons">
      <button 
        class="btn btn-primary" 
        [disabled]="isProcessing"
        (click)="onConfirmAddCandidate()">
        <span *ngIf="isProcessing" class="btn-spinner"></span>
        {{ isProcessing ? 'Creating Contact...' : 'Yes, Add Candidate' }}
      </button>
      <button 
        class="btn btn-secondary" 
        [disabled]="isProcessing"
        (click)="onCancelAddCandidate()">
        No, Cancel
      </button>
    </div>
  </div>
</div>

<!-- Toast Styles -->
<style>
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
</style>